import TimePickerLocale from '../../time-picker/locale/sq_AL';
const locale = {
    lang: {
        locale: 'sq',
        placeholder: 'Zgjidh datën',
        yearPlaceholder: 'Zgjidh vitin',
        quarterPlaceholder: 'Zgjidh tremujorin',
        monthPlaceholder: 'Zgjidh muajin',
        weekPlaceholder: 'Zgjidh javën',
        rangePlaceholder: ['Data e fillimit', 'Data e mbarimit'],
        rangeYearPlaceholder: ['Viti i fillimit', 'Viti i mbarimit'],
        rangeQuarterPlaceholder: ['Tremujori i fillimit', 'Tremujori i mbarimit'],
        rangeMonthPlaceholder: ['Muaji i fillimit', 'Muaji i mbarimit'],
        rangeWeekPlaceholder: ['Java e fillimit', 'Java e mbarimit'],
        today: 'Sot',
        now: 'Tani',
        backToToday: 'Kthehu te sot',
        ok: 'OK',
        clear: 'Pastro',
        week: 'Javë',
        month: 'Muaj',
        year: 'Vit',
        timeSelect: 'Zgjidh kohën',
        dateSelect: 'Zgjidh datën',
        weekSelect: 'Zgjidh javën',
        monthSelect: 'Zgjidh muajin',
        yearSelect: 'Zgjidh vitin',
        decadeSelect: 'Zgjidh dekadën',
        yearFormat: 'YYYY',
        fieldDateFormat: 'DD/MM/YYYY',
        cellDateFormat: 'D',
        fieldDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
        monthFormat: 'MMMM',
        fieldWeekFormat: 'YYYY-wo',
        monthBeforeYear: true,
        previousMonth: 'Muaji i mëparshëm (PageUp)',
        nextMonth: 'Muaji tjetër (PageDown)',
        previousYear: 'Viti i mëparshëm (Control + left)',
        nextYear: 'Viti tjetër (Control + right)',
        previousDecade: 'Dekada e mëparshme',
        nextDecade: 'Dekada tjetër',
        previousCentury: 'Shekulli i mëparshëm',
        nextCentury: 'Shekulli tjetër',
        shortWeekDays: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
        shortMonths: [
            'Jan',
            'Shk',
            'Mar',
            'Pri',
            'Maj',
            'Qer',
            'Kor',
            'Gus',
            'Sht',
            'Tet',
            'Nën',
            'Dhj',
        ],
    },
    timePickerLocale: {
        ...TimePickerLocale,
    },
};
export default locale;
